<template lang="pug">
.container
    //mobileHeader
    mainHeader
    headerBlock
    #recruit
        .head-img
            img.photo.pc(src="@/assets/img/photo/recruit/30.png")
            img.photo.sp(src="@/assets/img/photo/recruit/30.png")
        .title-img
            img.text(src="@/assets/img/photo/recruit/title.svg")
        section.recruit-info.about-work
            h2 仕事について
            ul
                li(v-for="item in about") {{ item.name }}：{{ item.contents }}
        section.recruit-info.table.new-graduates
            h2 新卒採用
            recruitTable(:tableData="newGraduates")
            a.mynavi(
                href="https://job.mynavi.jp/20/pc/search/corp210419/outline.html",
                target="_blank"
            ): img(
                src="@/assets/img/photo/recruit/mynavi.png"
            )
        section.recruit-info.table.mid-career
            h2 中途採用
            recruitTable(:tableData="midCareer")
        backtoTop.back
    footerBlock
</template>
<style lang="scss" scoped>
#recruit {
    @include container;
    > .head-img {
        width: 100%;
        height: auto;
        margin: 25px auto;
        position: relative;
        @media #{$pc} {
            width: 860px;
            height: 522px;
            margin: 64px auto 32px;
        }
        > .photo {
            width: 100%;

            &.pc {
                @media #{$phone} {
                    display: none;
                }
            }

            &.sp {
                display: none;
                @media #{$phone} {
                    display: block;
                }
            }
        }
        > .catch.pc {
            width: 386px;
            position: absolute;
            z-index: 2;
            bottom: 48px;
            right: 64px;
            @media #{$phone} {
                display: none;
            }
        }
    }

    > .title-img {
        width: 81px;
        height: 19px;
        margin: 48px auto;

        @media #{$pc} {
            margin: 72px auto;
        }
        > .text {
            width: 100%;
        }
    }
    > .sp-catch {
        display: none;
        @media #{$phone} {
            display: block;
            margin: 0 auto;
            width: 330px;
        }
    }
    > .recruit-info {
        width: 100%;
        padding: 55px 16px;
        margin: 0 auto;
        position: relative;

        &.about-work {
            @include shadow;
            background: #fff;
            color: $color-text;

            @media #{$pc} {
                margin-bottom: 75px;
            }
        }

        @media #{$pc} {
            @include shadow;
            width: 830px;
            padding: 75px 48px;
            background: #fff;
            margin-bottom: 32px;
        }

        &.table {
            @media #{$phone} {
                background: transparent;
                padding: 0 0;
                margin-top: 55px;
                width: 100%;
                border-bottom: 1.2px solid #8e8e8e;
            }
        }

        > h2 {
            text-align: center;
            margin-bottom: 55px;
            font-weight: normal;
            font-size: 18px;
            color: $color-text;
        }

        > ul {
            display: flex;
            flex-direction: column;
            width: 90%;
            margin: 0 auto;
            @media #{$phone} {
                width: 100%;
            }
        }

        > ul > li {
            display: inline-block;
            color: $color-text;
            margin: 3px 0;
            //font-family: $font-sub;
        }

        > .mynavi {
            width: 180px;
            position: absolute;
            bottom: 75px;
            right: 48px;

            > img {
                width: 100%;
            }
            @media #{$phone} {
                position: relative;
                display: block;
                margin: 24px auto;
                bottom: 0;
                right: 0;
            }
        }
    }
}

.back {
    margin-top: 48px;

    @media #{$pc} {
        margin-top: 64px;
    }
}
</style>

<script>
import mainHeader from "@/components/header-menu";
import headerBlock from "@/components/pc-header";
import backtoTop from "@/components/backto-top";
import footerBlock from "@/components/footer-block";
import recruitTable from "../components/recruit-table";
import mobileHeader from "@/components/mobile-header";
export default {
    components: {
        mainHeader,
        mobileHeader,
        headerBlock,
        backtoTop,
        footerBlock,
        recruitTable,
    },
    mounted() {
        window.scroll(0, 0);
    },
    data() {
        return {
            about: [
                {
                    name: "施工管理",
                    contents:
                        "各現場で具体的な指示を出し工事の進捗を管理・施工図や工程表を作成する",
                },
                {
                    name: "営業",
                    contents: "企画提案",
                },
                {
                    name: "設計",
                    contents: "リフォーム・リノベーションの設計",
                },
                {
                    name: "インテリアコーディネーター",
                    contents:
                        "リフォーム・リノベーションのインテリアコーディネート提案",
                },
            ],
            newGraduates: {
                terms: {
                    name: "雇用条件",
                    contents: [
                        { name: "初任給", contents: "大卒200,000円(手当含む)" },
                        {
                            name: "諸手当",
                            contents: "通勤手当・業務手当・資格手当",
                        },
                        { name: "昇給", contents: "年1回(10月) 業績による" },
                        {
                            name: "賞与",
                            contents:
                                "初年度 年1回(12月)/2年目 年2回(6月、12月)",
                        },
                        { name: "勤務地", contents: "広島県内" },
                        {
                            name: "勤務時間",
                            contents:
                                "平日8:00〜17:00/土曜日8:00〜17:00(休憩75分)",
                        },
                        {
                            name: "休日",
                            contents:
                                "日曜日、祝日他、年間休日会社カレンダーによる",
                        },
                        {
                            name: "休暇",
                            contents: "年次有給休暇、年末年始、夏季休暇",
                        },
                        {
                            name: "福利厚生",
                            contents:
                                "各種保険(社会、厚生年金・雇用・労災)完備、退職金制度(勤年数3年以上対象)、社員旅行、各種レクリエーション、資格取得支援制度",
                        },
                    ],
                },
                certified: {
                    name: "応募資格",
                    contents: [
                        "専門学校・大学・大学院卒",
                        "全学部・全学科",
                        "要普通自動車運転免許",
                    ],
                },
                documents: {
                    name: "提出書類",
                    contents: ["履歴書"],
                },
            },
            midCareer: {
                terms: {
                    name: "雇用条件",
                    contents: [
                        { name: "初任給", contents: "229,000円〜270,000円" },
                        {
                            name: "諸手当",
                            contents: "通勤手当・業務手当・資格手当",
                        },
                        { name: "昇給", contents: "年1回(10月) 業績による" },
                        {
                            name: "賞与",
                            contents:
                                "初年度 年1回(12月)/2年目 年2回(6月、12月)",
                        },
                        { name: "勤務地", contents: "広島県内" },
                        {
                            name: "勤務時間",
                            contents:
                                "平日8:00〜17:00/土曜日8:00〜17:00(休憩75分)",
                        },
                        {
                            name: "休日",
                            contents:
                                "日曜日、祝日他、年間休日会社カレンダーによる",
                        },
                        {
                            name: "休暇",
                            contents: "年次有給休暇、年末年始、夏季休暇",
                        },
                        {
                            name: "福利厚生",
                            contents:
                                "各種保険(社会、厚生年金・雇用・労災)完備、退職金制度(勤年数3年以上対象)、社員旅行、各種レクリエーション、資格取得支援制度",
                        },
                    ],
                },
                certified: {
                    name: "応募資格",
                    contents: ["高校卒以上", "要普通自動車運転免許"],
                },
                documents: {
                    name: "提出書類",
                    contents: ["履歴書"],
                },
            },
        };
    },
};
</script>
